import { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "umi";
import dailyFilterDefault from '@/pages/dashboard/filterPageComponents/overview/dailyFilterDefault';
import { getPcV2MetricsUsers } from '@/pages/dashboard/services/overview';
import { getDefaultUtcDateValue } from "@/pages/dashboard/utils/dateUtils";

const useData = (filterVal: any, filterLoading: boolean) => {
  const formVal = filterVal || dailyFilterDefault;
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const gameCode = useSelector((state: any) => state?.dashboard?.currentGame?.game_code, shallowEqual);

  // 点击筛选器的时候
  useEffect(() => {
    if (!filterVal) return;
    if (!filterLoading) {
      gePcMetricsDataFunc();
    }
  }, [formVal, filterLoading]);


  const gePcMetricsDataFunc = () => {
    const { filterValue, diff } = formVal;
    // 非继承，第一次进入页面折线图区14天、6周、6月
    const { rangeTime, ...filters } = filterValue;
    const defaultTimeRange = getDefaultUtcDateValue(formVal?.timeType, rangeTime);
    const rangeTimeArr = diff ? defaultTimeRange : rangeTime;
    const [start, end] = rangeTimeArr;
    const reqParams = {
      game_code: gameCode,
      filters,
      start_time: start,
      end_time: end,
      by_type: 'os',
    };
    setLoading(true);
    getPcV2MetricsUsers(reqParams).then((result: any) => {
      setError('');
      setLoading(false);
      setData(result);
    }).catch((err: any) => {
      setError(err);
      setLoading(false);
    });
  };
  return {
    // nodata 不在此封装，因为可能是接口的个别项目nodata
    data,
    loading,
    error,
    getData: gePcMetricsDataFunc
  };
};

export default useData;
